import { useState } from 'react';
export function CopyBox({ value }: { value: string }) {
  const [message, setMessage] = useState('');
  return (
    <div className="secret-box">
      <code style={{ flex: 1 }}>{value}</code>
      <button
        className="btn small"
        onClick={() => {
          void (async () => {
            try {
              await navigator.clipboard.writeText(value);
              setMessage('コピーしました');
            } catch {
              setMessage('コピーできませんでした。手動でコピーしてください。');
            }
          })();
        }}
      >
        コピー
      </button>
      {message && <span role="status">{message}</span>}
    </div>
  );
}
